import { useSnackbar } from 'notistack'

const useClipboard = () => {
  const { enqueueSnackbar } = useSnackbar()
  const clipboardAPIExists = Boolean(navigator && navigator.clipboard && navigator.clipboard.writeText)

  const clickToCopy = (text: string) => {
    if (clipboardAPIExists) {
      navigator.clipboard.writeText(text).then(
        () => {
          enqueueSnackbar('Copied to clipboard')
        },
        () => {
          enqueueSnackbar('Could not copy to clipboard')
        }
      )
    } else {
      enqueueSnackbar('To copy this to your clipboard, please use a recent version of Chrome, Firefox, Edge or Safari')
    }
  }

  return { clipboardAPIExists, clickToCopy }
}

export default useClipboard
